import { apiClient } from "@/lib/api-client";

export const fetchUnsurPenelitian = async ({
  niu,
  year,
  semester,
  periodeID,
}: {
  niu: string;
  year?: number | string;
  semester?: number | string;
  periodeID?: string | number | null;
}) => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  const params = new URLSearchParams();
  if (year !== undefined) params.append("year", year.toString());
  if (semester !== undefined) params.append("semester", semester.toString());
  if (periodeID !== undefined && periodeID !== null) {
    params.append("periodeID", periodeID.toString());
  }

  const resData = await apiClient<any>(
    `${baseUrl}/api/v1/unsur-penelitian/${niu}?${params.toString()}`,
    {
      headers: {
        Accept: "application/json",
      },
    }
  );

  return resData.datas || {};
};
